// extracted by mini-css-extract-plugin
export default {"password-form-button":"UpdatePassword_password-form-button__+QstE","password-btn-container":"UpdatePassword_password-btn-container__EHz8t"};